import React from "react";
import "../CSS/Services.css";


const Services1demo=()=>{
    return(
        <section className="ftco-section ftco-servicesection services1demo">
         
        <div className="container servianicon">
          <div className="row servicecardhm">
            <div className="col-md-3 ftco-animate servicecards">
              <div className="media d-block text-center block-6 services">
                <div className="icon d-flex mb-3">
                  <span className="flaticon-facial-treatment" />
                </div>
                <div className="media-body">
                  <h3 className="heading">Skin &amp; Beauty Care</h3>
                  <p style={{textAlign:"justify", color:"black"}}>
                  Enhance your natural glow with our expert Skin & Beauty Care services, tailored to nourish and rejuvenate your skin.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 ftco-animate servicecards">
              <div className="media d-block text-center block-6 services">
                <div className="icon d-flex mb-3">
                  <span className="flaticon-cosmetics" />
                </div>
                <div className="media-body">
                  <h3 className="heading">Makeup Pro</h3>
                  <p style={{textAlign:"justify",color:"black"}}>
                  Unleash your best look with our Makeup Pro services, perfect for every occasion with flawless, professional results.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 ftco-animate servicecards" >
              <div className="media d-block text-center block-6 services">
                <div className="icon d-flex mb-3">
                  <span className="flaticon-curl" />
                </div>
                <div className="media-body">
                  <h3 className="heading">Hair Style</h3>
                  <p style={{textAlign:"justify",color:"black"}}>
                  Achieve the perfect look with our expert Hair Styling services, tailored to match your unique style and personality.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
}

export default Services1demo;